<template>
<!-- Contenedor Principal-->
<b-container fluid>
  <div class="white">
    <h1 class="primer-fila text-center">Consulta de Licencias Personal</h1>
    <hr>
  </div>
</b-container>
</template>

<script>
export default {
  components: {  },
  name: 'ConsultaLicenciaPersonal',
  computed:{
  },
  watch: {

  },
  data() {
    return {

    }
  },
  methods: {
  },
  created() {
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/pages/licencias/ConsultaLicenciaPersonal.vue